// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__24Ry0","footer":"Form_footer__VBKk-"};